export default "__VITE_ASSET__Ya93LZU8__"